import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  displayProfileModal,
  setProfileModalPage,
} from '../../../modules/profile/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import AddCardPageForm from '../components/AddCardPageForm/AddCardPageForm'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState

  const { accessToken } = auth

  const { primaryInfo, showProfileModal, profileModalPage } = profile

  return {
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      displayProfileModal,
      setProfileModalPage,
      waitRenderServer,
      renderServer,
    },
    dispatch,
  )

const ConnectedAddCardPageForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddCardPageForm)

export default ConnectedAddCardPageForm
